import styled from 'styled-components';

export const ReviewersContainer = styled.div`
  display: flex;
  align-items: center;
  position: relative;
  min-height: 32px;
`;

export const ReviewerAvatar = styled.div<{
  size: number;
  pictureUrl: string;
  firstName: string;
  lastName: string;
  index: number;
  total: number;
}>`
  width: ${(props) => props.size}px;
  height: ${(props) => props.size}px;
  border-radius: 50%;
  background: ${(props) =>
    props.pictureUrl ? `url(${props.pictureUrl}) center/cover` : '#e2e8f0'};
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 11px;
  font-weight: 600;
  color: #4a5568;
  border: 2px solid #fff;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;
  z-index: ${(props) => props.total - props.index};

  /* Overlapping effect */
  margin-left: ${(props) => (props.index === 0 ? 0 : '-8px')};

  /* Hover animation */
  &:hover {
    transform: scale(1.15) translateY(-2px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15), 0 0 0 3px rgba(59, 130, 246, 0.1);
    z-index: 999;
  }

  &::before {
    content: '${(props) => props.firstName.charAt(0)}${(props) => props.lastName.charAt(0)}';
    display: ${(props) => (props.pictureUrl ? 'none' : 'flex')};
  }
`;

export const NoReviewersText = styled.span`
  color: #a0aec0;
  font-style: italic;
  font-size: 14px;
`;
